import WithHyperLink from 'library/hoc/withHyperLink';
import { uniqBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { palette } from 'theme/MainTheme';
import { Button, Card, Col, Flex, Input, Row, Table, Tag, Typography } from 'zui/Antd';

const { Search } = Input;
const { Text } = Typography;

const PeopleTable = ({ peopleData }) => {
	//Redux state
	const { data: sitesData } = useSelector((state) => state.Sites);

	//Local state
	const [filteredData, setFilteredData] = useState([]);
	const [cleanPeopleData, setCleanPeopleData] = useState([]);

	useEffect(() => {
		setFilteredData(peopleData.filter((person) => !person.deletedDate));
		setCleanPeopleData(peopleData.filter((person) => !person.deletedDate));
	}, [peopleData]);

	const handleSearch = (query, array) => {
		const searchResult = array.filter(
			(object) =>
				object.displayName.toLowerCase().includes(query.toLowerCase()) ||
				object.lastName?.toLowerCase().includes(query.toLowerCase()) ||
				object.firstName?.toLowerCase().includes(query.toLowerCase())
		);
		setFilteredData(searchResult);
	};

	const ButtonWithLink = WithHyperLink(() => <Button size='small'>View</Button>);

	// HOC
	const BaseLink = WithHyperLink((a) => {
		return <Text>{a.children}</Text>;
	});

	const SiteWithLink = (props) => {
		return <BaseLink {...props} />;
	};

	const NameWithLink = (props) => {
		return <BaseLink {...props} />;
	};

	const TeamWithLink = (props) => {
		return <BaseLink {...props} />;
	};

	const columns = [
		{
			title: 'Person',
			dataIndex: 'displayName',
			key: 'displayName',
			ellipsis: true,
			render: (text, record) => {
				return (
					<NameWithLink type='person' dataID={record.personID} title={record?.email}>
						{record?.displayName}
					</NameWithLink>
				);
			}
		},
		{
			title: 'Site',
			dataIndex: 'siteID',
			key: 'site',
			ellipsis: true,
			render: (text, record) => {
				const siteInfo = sitesData.find((site) => site.siteID === text);
				return (
					<SiteWithLink type='site' dataID={record.siteID} key={record.siteID}>
						{siteInfo && siteInfo.name}
					</SiteWithLink>
				);
			},
			filters: Array.from(new Set(peopleData.map((person) => person.siteID)))
				.map((siteID) => {
					const siteInfo = sitesData.find((site) => site.siteID === siteID);
					return siteInfo ? { text: siteInfo.name, value: siteID } : null;
				})
				.filter((item) => item !== null),
			onFilter: (value, record) => record.siteID === value
		},
		{
			title: 'Team',
			dataIndex: 'team',
			key: 'team',
			ellipsis: true,
			render: (team) => {
				return (
					<div
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							flexDirection: 'row'
						}}
					>
						{team?.length > 0 &&
							team.map((team) => (
								<TeamWithLink type='team' dataID={team.teamID} key={team.teamID}>
									<Tag
										size='small'
										color={palette.tagColor[team.teamID % 11]}
										style={{
											lineHeight: '13px',
											fontSize: '11px',
											marginTop: '4px',
											marginBottom: '4px'
										}}
									>
										{team.name}
									</Tag>
								</TeamWithLink>
							))}
					</div>
				);
			},

			filters: uniqBy(filteredData.map((person) => person.team).flat(), 'teamID').map((team) => ({
				text: team?.name,
				value: team?.teamID
			})),
			onFilter: (value, record) => record.team.some((t) => t.teamID === value)
		},
		{
			key: 'View',
			render: (record) => (
				<Flex justify='center'>
					<ButtonWithLink type='person' dataID={record.personID} />
				</Flex>
			),
			ellipsis: true
		}
	];

	return (
		<Card
			title='People'
			styles={{
				header: {
					fontSize: 20,
					borderBottom: 0
				},
				body: {
					paddingTop: 0
				}
			}}
		>
			<Row gutter={16} justify='start'>
				<Col lg={24} md={24} sm={24} xs={24}>
					<Search
						style={{ marginBottom: '10px', marginTop: '4px' }}
						placeholder='Search Person Name'
						enterButton='Search'
						loading={false}
						onChange={(query) => {
							handleSearch(query.target.value, cleanPeopleData);
						}}
						onSearch={(query) => {
							handleSearch(query, cleanPeopleData);
						}}
					/>
				</Col>
				<Col lg={24} md={24} sm={24} xs={24}>
					<Table
						columns={columns}
						dataSource={filteredData}
						pagination={{
							pageSize: 5
						}}
					/>
				</Col>
			</Row>
		</Card>
	);
};

export default PeopleTable;
